import { publicInstance } from "../config/axios"
import { getRememberMeToken } from "../utils"

export const loginUser = async ({ username, password }) => {
  const response = await publicInstance.post(
    `/auth/login`,
    {
      username,
      password,
    },
    {
      headers: {
        rememberMeToken: getRememberMeToken(),
      },
    }
  )
  return response.data
}

export const getAccessTokenViaRefreshToken = async (refreshToken) => {
  const response = await publicInstance.post("/auth/token/refresh", {
    refreshToken,
  })
  return response.data
}

export const logoutUser = async (refreshToken) => {
  await publicInstance.post("/auth/logout", {
    refreshToken,
  })
}
